import axios from 'axios';
import commonInterceptors from '@/shared/interceptors/common.interceptor.js';
import syncInterceptor from '@/shared/interceptors/sync.interceptor.js';
import fn from "@/shared/utils/commonFunctions.js";
import Vue from 'vue'

export async function Post(endpoint, data, keys, loader ,multiple) {
    let result = false;
    if (!fn.isEmpty(keys)){
        data["syncuniquekey"] = keys.map(x => x + '==' + data[x]).join('_')
    }
    if (multiple){
        data["avoidsynccancellation"] = true
    }
    let auxloader = loader != undefined ? Vue.$loading.show({container: loader, isFullPage: false}) : undefined
   await axios.post(endpoint, data, {
        headers: {
            'Content-Type': 'application/json'
        },
        LOADER: auxloader
    })
        .then(response => {
            console.log(response)
            result = response.data
        })
        .catch(error => {
            console.log(error);
        })
        .finally(function(){
            if (auxloader)
            auxloader.hide()
        });
    return result
}

export async function Get(endpoint, data, keys, loader, multiple) {
    let result = null;
    if (!fn.isEmpty(keys)){
        data["syncuniquekey"] = keys.map(x => x + '==' + data[x]).join('_')
    }
    if (multiple){
        data["avoidsynccancellation"] = true
    }
    let auxloader = loader != undefined ? Vue.$loading.show({container: loader, isFullPage: false}) : undefined
    await axios.get(endpoint, {
        headers: {
            'Content-Type': 'application/json'
        },
        params: data,
        LOADER: auxloader
    })
        .then(response => {
            console.log(response)
            result =  response.data
        })
        .catch(error => {
            console.log(error)
        })
        .finally(function(){
            if (auxloader)
            auxloader.hide()
        });

    return result


}

export async function Put(endpoint, data, keys, loader,multiple) {
    let result = false;
    if (!fn.isEmpty(keys)){
        data["syncuniquekey"] = keys.map(x => x + '==' + data[x]).join('_')
    }
    if (multiple){
        data["avoidsynccancellation"] = true
    }
    let auxloader = loader != undefined ? Vue.$loading.show({container: loader, isFullPage: false}) : undefined
    await axios.put(endpoint, data, {
        headers: {
            'Content-Type': 'application/json'
        },
        LOADER: auxloader
    })
        .then(response => {
            result =  response.data
        })
        .catch(error => {
            console.log(error);
        })
        .finally(function(){
            if (auxloader)
            auxloader.hide()
        });
    return result;
}

export async function Delete(endpoint, data, keys, loader, multiple) {
    let result = false;
    if (!fn.isEmpty(keys)){
        data["syncuniquekey"] = keys.map(x => x + '==' + data[x]).join('_')
    }
    if (multiple){
        data["avoidsynccancellation"] = true
    }
    let auxloader = loader != undefined ? Vue.$loading.show({container: loader, isFullPage: false}) : undefined
    await axios.delete(endpoint, {
        headers: {
            'Content-Type': 'application/json'
        },
        params: data,
        LOADER: auxloader
    })
        .then(response => {
            result =  response.data
        })
        .catch(error => {
            console.log(error);
        })
        .finally(function(){
            if (auxloader)
            auxloader.hide()
        });

    return result;

}

commonInterceptors.setCommonInterceptors(axios);
syncInterceptor.setSyncInterceptors(axios);

export default { Post, Get, Put, Delete }
